function wrapElement(element1, element2) {
  // Get the parent node of element1
  const parent = element1.parentNode;
  
  // Check if element1 is in the DOM
  if (!parent) {
    throw new Error("The first element is not in the DOM");
  }
  
  // Get the next sibling of element1 to preserve its position
  const next = element1.nextSibling;
  
  // Append element1 to element2 (this removes element1 from its current position)
  element2.appendChild(element1);
  
  // Insert element2 into the parent at the original position of element1
  parent.insertBefore(element2, next);
  
  // Return element2 (the wrapper)
  return element2;
}

export function addScrollOverlays(element, top = true, bottom = true) {

    if (!top && !bottom) return;

    const scrollableContainer = document.createElement('div');
    scrollableContainer.className = 'os-scrollable-overlay';
    let topOverlay, bottomOverlay;
    // Modify the element so it is a child of the scrollableContainer
    wrapElement(element, scrollableContainer);

    // Create the top overlay
    if (top) {
        topOverlay = document.createElement('div');
        topOverlay.style.position = 'absolute';
        topOverlay.style.top = '0';
        topOverlay.style.height = '12.5%';
        topOverlay.style.width = '100%';
        topOverlay.style.backgroundImage = 'linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))';
        topOverlay.style.pointerEvents = 'none';
        topOverlay.style.opacity = '0'; // Initially invisible
        topOverlay.style.transition = 'opacity 0.5s ease'; // Smooth transition
        topOverlay.style.zIndex = '1'; // Ensure it’s on top

        element.appendChild(topOverlay);
    }

    // Create the bottom overlay
    if (bottom) {
        bottomOverlay = document.createElement('div');
        bottomOverlay.style.position = 'absolute';
        bottomOverlay.style.bottom = '0';
        bottomOverlay.style.height = '12.5%';
        bottomOverlay.style.width = '100%';
        bottomOverlay.style.backgroundImage = 'linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))';
        bottomOverlay.style.pointerEvents = 'none';
        bottomOverlay.style.opacity = '0'; // Initially invisible
        bottomOverlay.style.transition = 'opacity 0.5s ease'; // Smooth transition
        bottomOverlay.style.zIndex = '1'; // Ensure it’s on top
        element.appendChild(bottomOverlay);
    }

    // Function to update overlay visibility based on scroll position
    function updateOverlays() {
        if (topOverlay) topOverlay.style.opacity = element.scrollTop > 0 ? '1' : '0';
        if (bottomOverlay) bottomOverlay.style.opacity = element.scrollTop + element.clientHeight < element.scrollHeight ? '1' : '0';
    }

    // Set initial state
    updateOverlays();

    // Update overlays when the user scrolls
    element.addEventListener('scroll', updateOverlays);
}